import React from "react";
import { ReactComponent as VisibilityOnIcon } from "../../Assets/svg/visibility.svg";
import { ReactComponent as VisibilityOffIcon } from "../../Assets/svg/visibility_off.svg";

import "./_style.scss";

function PasswordInput(props) {
  const validationMessage = props.isInvalid && props.errorMsg;
  const className =
    "form-control password" + (validationMessage ? " invalid" : "");

  const [inputType, setInputType] = React.useState("password");
  function togglePasswordVisibility() {
    setInputType(inputType === "password" ? "text" : "password");
  }

  return (
    <div className="password-input-container">
      <label htmlFor={props.label}>
        {props.label}{" "}
        {!props.isMandatory && <span className="optional-info">optional</span>}
      </label>

      <div className="input-group">
        <input
          className={className}
          type={inputType}
          name={props.label}
          placeholder={props.placeholder}
          onClick={props.onClick}
          onChange={props.onChange}
          onKeyDown={props.onKeyDown}
          onBlur={props.onBlur}
          disabled={props.disabled}
          value={props.value ? props.value : ""}
          pattern={props.pattern}
          onPaste={(e) => {
            if (props.notAllowPaste) {
              e.preventDefault();
            }
          }}
        />
        <button
          className="btn btn-outline-secondary"
          type="button"
          onClick={togglePasswordVisibility}
        >
          {inputType === "password" ? (
            <VisibilityOnIcon />
          ) : (
            <VisibilityOffIcon />
          )}
        </button>
      </div>
      {validationMessage && (
        <span className="text-error-message">{props.errorMsg}</span>
      )}
    </div>
  );
}

export default PasswordInput;
